import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const HubspotButtonWidget: WidgetRegistryEntry = {
  name: "HubspotButton",
  component: () => import("./hubspot-button-widget.component").then((c) => c.HubspotButtonWidgetComponent),
  configuration: () => import("./configuration").then((c) => c.HubspotButtonWidgetConfiguration)
};
